export async function convertHeicToJpeg(file: File): Promise<File> {
  const isHeic = file.type === 'image/heic' ||
                 file.type === 'image/heif' ||
                 file.name.toLowerCase().endsWith('.heic') ||
                 file.name.toLowerCase().endsWith('.heif')

  if (!isHeic) {
    return file
  }

  try {
    // @ts-expect-error
    const { heicTo } = await import('heic-to/csp')

    const convertedBlob = await heicTo({
      blob: file,
      type: 'image/jpeg',
      quality: 0.9,
    })

    const newFileName = file.name.replace(/\.(heic|heif)$/i, '.jpg')
    const convertedFile = new File([convertedBlob], newFileName, {
      type: 'image/jpeg',
      lastModified: file.lastModified,
    })

    return convertedFile
  } catch (error) {
    return file
  }
}

export async function convertHeicImages(files: File[]): Promise<File[]> {
  const convertPromises = files.map(file => convertHeicToJpeg(file))
  return Promise.all(convertPromises)
}

export async function compressImage(file: File): Promise<File> {
  const COMPRESS_THRESHOLD = 5 * 1024 * 1024

  if (!file.type.startsWith('image/')) return file
  if (file.type === 'image/gif' || file.type === 'image/svg+xml') return file
  if (file.size < COMPRESS_THRESHOLD) return file

  try {
    const img = new window.Image()
    const url = URL.createObjectURL(file)
    img.src = url

    await new Promise<void>((resolve, reject) => {
      img.onload = () => resolve()
      img.onerror = () => reject(new Error('Failed to load image'))
    })

    const canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)

    const blob = await new Promise<Blob>((resolve) => {
      canvas.toBlob((b) => resolve(b), 'image/jpeg', 0.7)
    })

    URL.revokeObjectURL(url)

    if (blob.size >= file.size) return file

    const newFileName = file.name.replace(/\.[^.]+$/, '.jpg')
    const compressedFile = new File([blob], newFileName, {
      type: 'image/jpeg',
      lastModified: file.lastModified,
    })

    return compressedFile
  } catch (error) {
    return file
  }
}

export async function compressFileImages(files: File[]): Promise<File[]> {
  const compressPromises = files.map(file => compressImage(file))
  return Promise.all(compressPromises)
}

